import { IBKJComboBoxAsyncProps } from '@bookjane2/bookjane-design-library/lib/components/BKJComboBoxAsync/BKJComboBoxAsync.types';

export function getIsInitialOptionIncludedInData(
  initialOption: IBKJComboBoxAsyncProps['value'] | undefined,
  options: IBKJComboBoxAsyncProps['options'],
) {
  if (!initialOption) return false;
  return options.some((option) => `${option.value}` === `${initialOption.value}`);
}
